import type { ReactNode } from 'react'

import type { Variant } from '../list.context'
import { ListProvider } from '../list.context'

import * as styles from './base-list.styles'

type Props = {
  component: 'ul' | 'ol'
  variant: Variant
  children: ReactNode
  className?: string
}

export const BaseList = ({
  component,
  variant,
  children,
  className,
  ...rest
}: Props) => {
  const Component = component

  return (
    <Component
      className={className}
      css={[styles.root, styles.variant[variant]]}
      data-testid="base-list"
      {...rest}
    >
      <ListProvider variant={variant}>{children}</ListProvider>
    </Component>
  )
}
